import axios from 'axios';
import UAParser from 'ua-parser-js';
import useGetLocationData from '../hooks/useGetLocationData';
import { useRecoilValue } from 'recoil';
import { languageState } from '../recoil/language/languageAtom';
import { v4 as uuidv4 } from 'uuid';
import { countryState } from '../recoil/country/countryAtom';

const useApi = (apiVersion) => {
  const countryData = useRecoilValue(countryState);
  const selectedLanguage = useRecoilValue(languageState);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (!localStorage.getItem('uuid')) {
    const newUuid = uuidv4();
    localStorage.setItem('uuid', newUuid);
  }

  const uuid = localStorage.getItem('uuid');

  let locationData = {
    location: 'seoul', // local 환경에서 기본값
  };

  // 로컬 환경에서 제외(local 환경에서 cors error)
  if (process.env.NODE_ENV !== 'development') {
    locationData = useGetLocationData('https://location.mubeat.tv/');
  }
  const parser = new UAParser();
  const { browser, device } = parser.getResult();

  const config = {
    osName: 'Web',
    userCountry: countryData?.country,
    appVersion: '1.2.0', // TODO: 라이브 배포 시 최신 버전으로 업데이트
    deviceManufacturer: device?.vendor,
    deviceModel: device?.model,
    userLocale: selectedLanguage, // 사용자가 선택한 언어 정보
    userTimeZone: userTimeZone,
    mediaLocation: locationData?.location, // local 환경에선 seoul
    deviceType: device?.type === undefined ? 'desktop' : device?.type, // desktop의 경우 parser의 반환값이 undefined라 별도의 string 부여
    browserName: browser?.name,
    browserVersion: browser?.version,
    duid: uuid,
  };

  // 인자로 전달하는 버전에 따라 baseURL 결정, env값 가져와서 세팅
  const getBaseURL = () => {
    switch (apiVersion) {
      case 'v1':
        return process.env.REACT_APP_API_URL_V1;
      case 'v2':
        return process.env.REACT_APP_API_URL_V2;
      default:
        return process.env.REACT_APP_API_URL_V2;
    }
  };

  const api = axios.create({
    baseURL: getBaseURL(),
    headers: {
      'os-name': config.osName,
      'user-country': config.userCountry,
      'app-version': config.appVersion,
      'device-manufacturer': config.deviceManufacturer,
      'device-model': config.deviceModel,
      'user-locale': config.userLocale,
      'user-time-zone': config.userTimeZone,
      'media-location': config.mediaLocation,
      'device-type': config.deviceType,
      'browser-name': config.browserName,
      'browser-version': config.browserVersion,
      duid: config.duid,
    },
  });

  return api;
};

export default useApi;
